import { createThemedComponent } from "@vitalsource/vstui/themes";
import { Button } from "@vitalsource/vstui";
import styled from "styled-components";
import React from "react";

const VstuiWhiteButton = createThemedComponent(Button, props => ({
  Button_borderColor_whiteNaked: props.theme.vstui.color.white,
  Button_borderColor_whiteNaked_hover: props.theme.vstui.color.white,
  Button_borderColor_whiteNaked_active: props.theme.vstui.color.white,
  Button_borderColor_whiteNaked_focus: props.theme.vstui.color.white
}));

export const WhiteButton = props => {
  const overrideProps = { color: "white", tooltipPlacement: "bottom-end" };

  if (!props.favorite) {
    overrideProps.naked = true;
  }
  return <VstuiWhiteButton {...props} {...overrideProps} />;
};

const VstuiRoundWhiteButton = createThemedComponent(WhiteButton, {
  Button_borderRadius: "100px",
  Button_paddingHorizontal_withIconSmall: "0px",
  Button_paddingHorizontal_withIconMedium: "0px",
  Button_paddingHorizontal_withIconLarge: "0px"
});

// TODO: Can we get these sizes from the vstui theme, or can vstui be made to support circle buttons better?
const sizedRoundWhiteButtons = {
  small: styled(VstuiRoundWhiteButton)`
    width: 32px;
    height: 32px;
    & svg {
      transform: scale(0.75);
    }
    button {
      width: 100%;
    }
  `,
  medium: styled(VstuiRoundWhiteButton)`
    width: 40px;
    height: 40px;
    button {
      width: 100%;
    }
  `,
  large: styled(VstuiRoundWhiteButton)`
    width: 48px;
    height: 48px;
    button {
      width: 100%;
    }
  `
};

export const RoundWhiteButton = ({ size = "medium", ...restProps }) => {
  const MyButton = sizedRoundWhiteButtons[size];
  return <MyButton {...restProps} size={size} />;
};
